define([], function () {
    var framework = {
        "title.error": "错误",
        "title.prompt": "提示",
        "title.confirm": "确认",
        "title.warn": "警告",

        "hasBindUniportal": "您的华为云帐号已升级为HUAWEI ID，请使用HUAWEI ID登录",
        

        "mobileLoginModel.intlIpTip": "仅支持中国大陆地区手机号。",
        "mobileLoginModel.mobileLogin": "手机号登录",
        "mobileLoginModel.accountLogin": "帐号/邮件地址登录",
        "mobileLoginModel.mobilePlaceHolder": "手机号",
        "mobileLoginModel.accountPlaceHolder": "帐号名/邮件地址",
        "mobileLoginModel.userPlaceHolder": "用户名/邮件地址",
        "mobileLoginModel.notRegisterTip": "当前手机号尚未注册华为云。",
        "mobileLoginModel.isMobileTip": "似乎输入的是手机号，建议切换为 ",
        "mobileLoginModel.registerNow": "立即注册",
        "mobileLoginModel.multiUsersTip": "当前手机号已绑定多个华为云帐号，请选择本次要登录的帐号。",
        "mobileLoginModel.operationTooFrequent": "您的操作过于频繁，请{0}分钟后重试。",
        "mobileLoginModel.invalidNumber": "输入值不是有效手机号。",
        "mobileLoginModel.retry": "重试",
        "mobileLoginModel.retrievePwd": "找回密码",
        "emailLoginModel.multiUsersTip": "当前邮件地址已绑定多个华为云帐号，请选择要登录的帐号名。",   
        "fpwd.multiEmailUsersTip": "当前邮件地址绑定了多个华为云帐号，请选择本次要重置密码的帐号。",     

        "loginRegistTip":"当前仅对受邀用户开放注册。",
        "activeAccount":"确认激活",
        "uniportalTip":"华为官网用户，华为企业业务合作伙伴，华为员工，ICT开发者等",
        "activeAccountMsg":"尊敬的华为用户，这是您首次登录华为云，您需要了解并同意华为云用户协议及隐私政策声明以完成业务激活。",
        "accountName":" 帐户名",
        "userNameTip":"用户名：",
        "searchBoxPlaceHolder": "请输入关键字",
        "submitBtnTxt": "确定",
        "cancelBtnTxt": "取消",
        "btnTxtOK": "确定",
        "btnTxtCancel": "取消",
        "btnTxtYes": "是",
        "btnTxtNo": "否",
        "logout": "退出",
        "connect" : "和",
        "emptyStr": "--",
        "mobileMsgCodeTxt":"获取验证码",
        "mobilePasswordPlaceHolder":"密码",
        "blankTxt": "该项不能为空。",
        "emptyTxt": "该项不能为空且不能包含空格。",
        "nameBlankTxt": "该项不能为空。",     
        "passwordEqual": "两次输入密码必须保持一致。",
        "validEmail": "请输入有效的邮件地址。",
        "validPhone": "请输入有效的手机号。",
        "maxLenTxt": "最长不能超过{0}个字符。",
        "minLenTxt": "最短不能少于{0}个字符。",
        "minMaxLenTxt": "{0}~{1}个字符。",
        "mobileMinMaxLenTxt" : "{0}到{1}个字符",
        "phoneMaxLenTxt": "最长不能超过{0}位数字。",
        "msgCodeErrorInfo": "仅支持数字。",
        "nameContainsChar": "只能包含字母、数字或特殊字符(-_)且只能以字母或-开头。",
        "commonContainsChar": "只能包含大小写字母和数字。",
        "pwdNotUsernameOrInvert": "不能与用户名或倒序的用户名相同。",
        "pwdNotContsMobileOrEmail": "不能包含手机号或邮件地址。",
        "pwdNotContsMobile": "不能包含手机号。",
        "pwdcantContsMobileOrEmail": "密码不能包含手机号或邮件地址。",
        "pwdWeak":"您输入的密码可能存在泄漏风险，请更换其他密码。",
        "usernameNotPwdOrInvert": "不能与密码或倒序的密码相同。",
        "passwordChars": "至少包含以下字符中的{0}种：大写字母、小写字母、数字和特殊字符（~`! ?,.:; -_'\" ( ) { } [ ] /<>@# $% ^& * + |\\ =和空格）。",
        "mobilepasswordChars": "数字、大小写字母、特殊字符至少包含两种。",
        "mobilePasswordChars1": "至少包含以下两种：",
        "mobilePasswordChars2": "数字、大写字母、小写字母、特殊字符。",
        "validEmailOrPhone": "请输入有效的邮件地址或手机号。",
        "validAccountName": "请输入有效的帐号名。",
        "validPwd": "请输入有效的密码",
        "validAgency": "请输入有效代理名称",
        "validCheckCode": "验证码最长不能超过4个字符。",
        "tooMuchErrorCode": "验证码错误次数过多，请重新获取。",
        "pwdCannotEqualName": "密码不能与用户名或倒序的用户名相同。",
        "passwordPolicy.errorMsgOfRptChar": "密码中不允许出现 {0} 个以上连续相同的字符。",
        "inValidCcompanyName": "不能全是英文特殊字符、全是数字、全是空格、全是tab。",
        "companyNameLength": "最长不能超过32个字符。",
        "registerSucWarning":"在24小时内点击注册邮件地址中的链接，激活帐号。",
        "RegisterInfo":"已激活 立即体验",
        "accountTipInfo":"你的帐号信息如下：",
        "yes": "是",
        "no": "否",
        "iamUserTip": "如果管理员将您添加到华为云帐户，则您是IAM用户。",
        "registerFailed": "注册失败。",
        "recommended": "新手推荐",
        "strengthLow": "弱",
        "strengthMid": "中",
        "strengthHigh": "强",

        accountNameBlank: "帐号名不能为空。",
        userNameBlank: "用户名不能为空。",
        pwdBlank: "密码不能为空。",
        checkCodeBlank: "验证码不能为空。",

        backToHomepage: "返回首页",
        mobileHome: "首页",
        backTo: "返回",
        homepage: "首页",

        "isHwsUser": "该帐号是华为云（中国站）的帐号，请前往登录",
        "isHongKongUser": "该帐号是华为云（国际站）的帐号，请前往登录",
        "isRuUser": "该帐号是华为云（国际站）的帐号，请前往登录",
        "isHwsUser1": "该帐号是华为云（中国站）的帐号，请",
        "isHongKongUser1": "该帐号是华为云（国际站）的帐号，请",
        "isRuUser1": "该帐号是华为云（国际站）的帐号，请",
        "goLogin.hws": "前往登录",
        "goLogin.hk": "前往登录",
        "goLogin.ru": "前往登录",
        "toLogin.hws": "",
        "toLogin.hk": "",
        "toLogin.ru": "",


        "language": "简体中文",
        "lanuage.hk":"International",
        "lanuage.ch":"中国站",
        "language.zh-cn": "简体中文",
        "language.en-us": "English",
        "titles.login": "用户登录—华为云",
        "titles.resetPwd": "重置密码—华为云",
        "titles.fpwd": "找回密码—华为云",
        "titles.register": "用户注册—华为云",
        "titles.agencyRegister": "代理注册—华为云",
        "titles.reactivate": "重新激活—华为云",
        "titles.registerSuccess": "注册成功—华为云",
        "titles.fphone": "更换手机号",
        "titles.loginVerification": "登录验证—华为云",
        "titles.bindAccount": "首次登录—华为云",
        "titles.bindAccountSuccess": "注册成功（注册绑定）—华为云",

        registerFree: "注册",
        freeRegister: "免费注册",
        createDomain : "创建帐号",
        createDomainBtn : "创建并绑定",
        createSubUser : "创建IAM用户",
        createFailed : "创建失败。",
        bindDomain : "绑定帐号",
        createDomainLink:"创建帐号",
        bindDomainLink:"绑定帐号",
        bindFailed : "绑定失败。",
        bindRepeat : "您已绑定过其他合作伙伴帐号，不允许重复绑定。",
        "createDomain.remindCompleteInfo" : "请您填写以下信息创建华为云帐号并进行绑定。已有帐号？",
        "bindDomain.remindCompleteInfo" : "请您输入已有的华为云帐号信息并进行绑定。还没有帐号？",
        "createSubUserInfo" : "请您填写以下信息创建华为云IAM用户帐号并进行绑定。",
        enterpriseUser: "IAM用户登录",
        enterpriseUserLogin: "IAM用户",
        personageUser: "帐号登录",
        enterpriseUser4Intl: "IAM用户登录 (国际站)",
        personageUser4Intl: "帐号登录 (国际站)",
        accountPlaceHolder: "帐号名",
        domainPlaceHolder: "代理帐号ID/名称",
        roleNamePlaceHolder: "代理名称",
        failedToswitchRole: "切换代理失败",
        switchSubmit: "切换角色",
        agencyDesc: "允许使用单个用户ID和密码跨帐号管理资源。AWS管理员配置角色并为您提供帐号和角色详细信息之后，您便可切换角色。",
        userNamePlaceHolder: "用户名/邮件地址/手机",
        HongKongUserNamePlaceHolder: "IAM用户名/邮件地址",
        accountNamePlaceHolder: "帐号名/邮件地址/手机",
        HongKongAccountNamePlaceHolder: "帐号名/邮件地址",
        accountTip: "帐号：",
        passwdPlaceHolder: "密码",
        iamPasswdPlaceHolder: "IAM用户密码",
        verifyCodePlaceHolder: "验证码",
        "GraphicsVerifyCodeLabel": "验证码：",
        GraphicsVerifyCode: "安全检查",
        InputGrapVerifyCodeInfo: "为了您的帐号安全，请输入图形验证码。（请切换为英文输入键盘）",
        GrapVerifyCodeFailed: "图形验证码输入错误或已失效，请重试。",
        "getVerifyCode": "点击重新获取验证码",
        loginSubmit: "登录",
        logining: "正在登录...",
        rememberName: "记住登录名",
        rememberLogin: "记住登录信息",
        forgetPwd: "忘记密码",
        mobileforgetPwd: "忘记密码",
        emaiNamePwd: "邮件地址验证错误。",
        phoneNamePwd: "手机号验证错误。",
        domainNamePwd: "帐号名验证错误。",
        wrongNamePwd: "帐号密码验证错误。",
        //输入框tip
        learnMore: "了解更多",
        iamAccountTip: "IAM用户所属帐号名称。",
        iamUsernameTip: "由帐号管理员在IAM中创建的IAM用户。",
        iamAccountTipHelp: "/productdesc-iam/iam_01_0023.html?utm_campaign=ua&utm_content=iam&utm_term=login#section0",
        iamUsernameTipHelp: "/productdesc-iam/iam_01_0023.html?utm_campaign=ua&utm_content=iam&utm_term=login#section1",

        userNameMobliePH: "手机号",
        mobileNumberLogin:"使用 手机号 登录",
        noMobileLogin:"使用 帐号名/邮件地址 登录",
        phoneBlank: "手机号不能为空",
 
        wrongIPBlacklist: "检测到您的设备不安全，请更换设备登录",
        wrongIPFrequencyLimiting: "同一IP登录数量超限，请稍晚再登录",
        wrongEquipmentIDFrequencyLimiting: "同一设备登录数量超限，请稍晚再登录或更换设备登录",
        MachineOperation: "检测到您的设备不安全，请更换设备登录",

        emaiNamePwdChances: "邮件地址验证错误，再输错{0}次后需要重新登录。",
        phoneNamePwdChances: "手机号验证错误，再输错{0}次后需要重新登录。",
        domainNamePwdChances: "帐号名验证错误，再输错{0}次后需要重新登录。",
        wrongNamePwdChances: "帐号密码验证错误，再输错{0}次后需要重新登录。",
        wrongNamePwdFourChances: "身份验证信息错误，再输错4次该用户将被锁定15分钟。",
        wrongNamePwdThreeChances: "身份验证信息错误，再输错3次该用户将被锁定15分钟。",
        wrongNamePwdTwoChances: "身份验证信息错误，再输错2次该用户将被锁定15分钟。",
        wrongNamePwdoneChances: "身份验证信息错误，再输错1次该用户将被锁定15分钟。",
        userAccountsStopped: "用户已被停用,请联系管理员。",
        domainAccountsStopped: "帐号已被停用",
        userAccountsLocked: "用户名或密码错误达到5次，当前登录的IP地址已被锁定，请15分钟后重试。",
        clientIpInvalid: "您的管理员已设置了控制台ACL规则，禁止您所在的终端登录控制台。",
        userNotExist: "当前用户不存在，请联系管理员确认。",
        "clientIpInvalid.learnMore": "详情请查看",
        "clientIpInvalid.helpUrl": "/zh-cn/usermanual-iam/iam_07_0003.html",
        notAllowFpwd: "您不允许从本机找回密码。",
        warning: "警告",
        "systemException": "系统繁忙，请刷新页面后重试。",
        freqLocked: "尝试次数过多，请稍后重试。",
        wrongVerifyCode: "验证码错误或已失效。",
        invalidInput: "输入参数不合法。",
        serviceUrlInvalid: "登录失败，请<a href='/'>点击此处</a>重试。",
        maxSessionLimit: "该用户同时在线的会话数超过系统限制。",
        "multiUserInvalid": "您已成功登录，请刷新页面",
        "pageTimeout": "当前页面信息已失效，请刷新后重试。",
        "accountClosed": "您登录的帐户正在注销中",
        invalidInputFourChances: "输入参数不合法，再输错4次该用户将被锁定15分钟。",
        invalidInputThreeChances: "输入参数不合法，再输错3次该用户将被锁定15分钟。",
        invalidInputTwoChances: "输入参数不合法，再输错2次该用户将被锁定15分钟。",
        invalidInputoneChances: "输入参数不合法，再输错1次该用户将被锁定15分钟。",
        loginReactivateFail: "帐号尚未激活，发送激活邮件失败，请重试。",
        pwdSame: "新密码不能与旧密码相同。",
        initialPwdSame: "新密码不能与初始密码相同。",
        historyPwdSame: "新密码不能与历史密码相同。",
        copyrightNotice1: "©{0} Huaweicloud.com 版权所有",
        copyrightNotice1_hk: "版权所有 © 华为服务（香港）有限公司及其关联公司 {0} 保留一切权利",
        copyrightNotice2: "保留一切权利",
        copyrightNotice3: "黔ICP备20004760号-14",
        copyrightNotice4: "苏B2-20130048号",
        copyrightNotice5: "贵公网安备 52990002000093号",
        "legalNotice": "法律声明",
        "legalStatement": "法律声明",
        "reportAbuse": "举报不良信息",
        "sa_nisr": "可接受的使用政策",
        "sa_nisr_intl": "可接受使用政策",
        "siteTerms": "网站条款",
        "privacyProtect": "隐私政策声明",
        "privacyStrategyStatement": "隐私政策声明",
        "sa_cua": "华为云用户协议",
        "sa_cua_intl": "华为云用户协议",
        "enterpriseSwitchTip": "此登录模式适用于企业内用户，即由企业管理员创建的用户。",
        "personalSwitchTip": "此登录模式适用于帐号，即注册时同步创建的用户帐号。",
        "usingOtherWaysLogin": "使用其他帐号登录",
        "otherWaysLogin": "其他帐号登录",
        "HWSdeveloper": "华为终端开发者",
        "HWICTdeveloper": "华为ICT开发者",
        "hwportal": "华为官网帐号",
        "WeLink": "WeLink帐号",
        "mobilereadAgree" : "我同意",
        readAgree: "我已阅读并同意",
        hwCloudAgreement: "《华为云用户协议》",
        secretprotect : "《隐私政策声明》",
        companyUserRegistration: "企业用户注册",
        personalUserRegistration: "用户注册",
        companyAccountName: "用户名：",
        userName: "用户名： ",
        "mobileRegisterMail" : "激活邮件已发送至邮件地址：",
        registerMail: "注册邮件地址：",
        password: "密码： ",
        registerMailStep3:"邮 箱：",
        tipsAccount:"您的帐号信息如下：",
        passwordPlaceHolder: "请设置您的密码",
        confirmPassword: "确认密码： ",
        confirmPasswordPlaceHolder: "请再次输入您的密码",
        companyName: "公司名称： ",
        contact: "联系人： ",
        phoneNum: "手机： ",
        phonePlaceHolder: "请输入您的手机号",
        msgCode: "短信验证码： ",
        msgCodeTxt: "免费获取短信验证码",
        "msgPHTxt":"短信验证码",
        msgCodeTxtWait: "{0}秒后可重新获取",
        msgCodeWrong: "短信验证码错误。",
        region: "区域： ",
        "register.submit": "同意协议并注册",
        "register.finish": "完成",
        "register.mobilesubmit" : "下一步",
        innerKeyWord: "不能使用系统内部关键字作为开头。",
        accountNamePH: "请设置您的用户名",
        "emailPH" : "设置邮件地址",
        "mobileCompanyName" : "请输入您的公司名(选填)",
        companyNamePH: "请输入您的公司名",
        "registerSuccess": "恭喜您，注册成功！",
        "pleaseCompleteInfo": "为了提高帐号的安全性，请及时完善您的公司信息。",
        "complete": "完善",
        "companyInfo": "公司信息",
        "rejectAndBack": "返回",
        "homePage": "首页",
        "period": "。",
        "goTo": "前往",
        "myCredential": "My Credential",
        "completeUserInfo": "完善个人信息 。",
        "fpwd.findPasswd": "找回密码",
        "fpwd.enterpriseName": "帐号名：",
        "fpwd.accountName": "注册邮件地址或手机：",
        "fpwd.SMSVerifyCode": "请输入短信验证码",
        "fpwd.emailVerifyCode": "请输入邮件验证码",
        "fpwd.getCode": "免费获取验证码",
        "fpwd.confirmAccount": "确认帐号",
        "fpwd.resetPwd": "重置密码",
        "fpwd.resetSuccess": "完成",
        "fpwd.findSuccess": "修改成功！",
        "fpwd.newPasswd": "新密码：",
        "fpwd.confirmPasswd": "确认密码：",
        "fpwd.enterpriseNamePH": "请输入帐号名",
        "fpwd.accountNamePH": "请输入邮件地址/手机",
        "fpwd.verifyCodePH": "请输入验证码",
        "fpwd.newPasswdPH": "请输入新密码",
        "fpwd.newPasswdPHApp": "新密码",
        "fpwd.nextStepBtn": "下一步",
        "fpwd.backTo": "上一步",


        "fpwd.titleDetail": "请输入您的华为云帐号信息",
        "fpwd.titleIAMDetail": "请输入IAM用户信息",
        "fpwd.multiUsersTip": "当前手机号绑定了多个华为云帐号，请选择本次要重置密码的帐号。",
        "fpwd.accountConfirm": "帐号确认",
        "fpwd.personalAccount": "帐号",
        "fpwd.IAMAccount": "IAM用户",
        "fpwd.typePersonalTip": "注册华为云时创建的帐号",
        "fpwd.typeIAMTip": "由帐号管理员在IAM中创建的用户",
        "fpwd.IAMAccountNamePH": "IAM用户名/邮件地址/手机",
        "fpwd.identityVerification": "身份验证",
        "fpwd.identityVerificationDec": "您希望以何种方式验证身份？",
        "fpwd.passwordReset": "密码重置",
        "fpwd.passwordResetDesc": "设置您的新密码",
        "fpwd.step1.fpwdByemail": "通过帐号/邮件地址找回",
        "fpwd.step2.verificationCodePH": "请输入验证码",
        "fpwd.step2.unbindDesc": "您的帐号没有绑定邮件地址或手机，无法验证您的身份。",
        "fpwd.step2.unbindIAMDesc": "您的IAM用户没有绑定邮件地址或手机，无法验证您的身份。",
        "fpwd.step2.exceptionService": "若该手机号/邮件地址不可用，请联系管理员为您重置密码",
        "fpwd.step2.sendEmailCode": "向邮件地址{0}发送验证码",
        "fpwd.step2.sendMobileCode": "向手机{0}发送验证码",
        "fpwd.step2.unabledMethod": "以上验证方式不可用",
        "fpwd.step2.helpMsg": "请联系人工客服获取帮助",
        "fpwd.step2.helpTel1": "中国大陆:  +86 4000-955-988",
        "fpwd.step2.helpTel2": "中国香港:  +852 800 931 122",
        "fpwd.retrieveTxt": "重新获取（{0}）",
        "fpwd.step3.showPwdTip": "点击显示密码",
        "fpwd.step3.hidePwdTip": "点击隐藏密码",
        "fpwd.goToLogin": "去登录",
        "fpwd.successTxt": "密码重置成功",
        "fpwd.loginCountdownTxt": "{0}秒后返回登录页",


		"resetPwd.apiKeyTitle": "修改API密码",
        "resetPwd.apiKeyDetail": "为了提高帐户的安全性，请您修改API密码。",
        "resetPwd.apkKey": "原API密码：",
        "domainuserAccountsLocked": "帐号邮件地址尚未激活，请前往邮箱完成验证。",
        "fpwd.sendCodeFailed": "系统繁忙，获取验证码失败。",
        "fpwd.getCodeFail": "验证码获取次数已达到上限5次，请于次日重试。",
        "wrong_sendCodeFailed": "验证码发送失败,请重新点击获取。",
        "fpwd.invalidVerifyCode": "验证码错误，请重新输入。",
        "fpwd.ipLocked": "IP已被锁定",
		"fpwd.MultipleIAMUserNameByMobile": "该手机号绑定了多个IAM用户，请通过邮件地址找回密码。",
        "fpwd.MultipleAccountNameByMobile": "该手机号绑定了多个帐号，请输入正确的帐号名。",
        "fpwd.MultipleAccountNameByMobileError": "该手机号绑定了多个帐号，手机端暂不支持在该情况下找回密码。请在电脑端通过浏览器操作，或者使用邮件地址找回密码。",
		"fpwd.MultipleAccountsByMobileReminder": "当多个帐号名使用同一个手机号时，该栏为必填项。",
		"fpwd.EnterCorrectEnterpriseAccount": "请输入正确的帐号名。",
        "fpwd.EnterCorrectMobile": "您输入的手机号不正确或未注册， 请重新输入。",
        "fpwd.EnterCorrectEnterpriseAccountAndMobile": "请输入正确的帐号名和手机号。",
        "fpwd.EnterCorrectEmail": "请输入正确的邮件地址。",
        "fpwd.EnterCorrectEnterpriseAccountAndEmail": "请输入正确的帐号名和邮件地址。",
        "fpwd.EnterCorrectEnterpriseVerificationCode": "请输入正确的图形验证码。",
        "operationTooFrequent": "您的操作过于频繁，请稍后重试。",
        "fpwd.contactService": "提示：如果您手机和邮件地址均不可使用，请您联系人工客服{0}获取帮助。", //4000-955-988 // +7（495）800 1 800
        "fpwd.contactHKService": "提示：如果您的邮件地址不可使用，请您联系人工客服{0}获取帮助。",
        "fpwd.ErrorRegionAccount": "该帐号非华为云帐号",
        
        bindPhone: "绑定手机：",
        bindPhoneNum:"手 机：",
        "alreadyHaveAccount": "已有帐号，立即",
        "login": "登录",
        "loginNow": "立即登录",
        safetyDegree: "安全程度：",
        handsRegisterInfo: "使用华为掌上云服务的用户请点此",
        hansRegistration: "注册",
        filloutRegisterInfo: "填写注册信息",
        checkAccountInfo: "完善帐号信息",
        registerSucceed: "注册成功",
        congratulationsSucceed: "恭喜您注册成功！",
        successAccoutInfo: "您的帐号为：",
        descriptionInfo: "您可以使用用户名、绑定手机和电子邮箱作为登录名进行登录。",
        linkFailed: "对不起，此链接已失效。",
        linkFailedDetail: "可能您已经完成激活，或者超过有效激活时间。",
        linkFailedHelp: "您可以尝试",
        linkFailedLogin: "登录",
        serverTimeout: "对不起，服务器超时，请稍后再试。",
        mainMsg: "激活邮件已发送至邮件地址：",
        secondMsg: "请在24小时内点击注册邮件地址中链接，完成激活。",
        checkEmail: "立即打开邮件地址",
        "mobileCheckEmail" : "已激活 立即体验",
        didNotGetEmail: "没有收到邮件？",
        checkSpamMail: "1、请检查是否在垃圾邮件中",
        stillDidNotGetEmail: "2、如果还没收到，",
        resendEmail: "重新发送邮件",
        alwaysDidNotGetEmail: "3、一直收不到，",
        changeMailbox: "请更换邮件地址",
        replaceEmailTip: "24小时内仅允许更换一次邮件地址，请仔细核对输入的邮件地址。",
        sendNewEmail: "发送激活邮件",
        alreadySend: "激活邮件已重新发送。",
        sendFailed: "邮件发送失败。",
        inputEmail: "请输入您的邮件地址",
        "email": "邮件地址： ",
        countToHomepage: "{0}秒后返回登录页面",
        "registerFailed.emailRepeat": "该邮件地址已被注册。",
        "registerFailed.nameRepeat": "该用户名已被注册。",
        "registerFailed.mobileRepeat": "该手机号已被注册。",
        "registerFailed.nameCannotBegin": "不能以数字或_开头。",
        "registerFailed.nameCannotContain": "只能包含：字母、数字或-_字符。",

        "registerSuccess.backToHomepage": "1、",
        "registerSuccess.returnHomepage":"返回首页",
        "usercompanyAccount":"您的帐号信息如下:",
        "registerSuccess.backToHomepageLink": "返回首页",
        "registerSuccess.backToHomepageLinkP1": "返回",
        "registerSuccess.backToHomepageLinkP2": "华为云",
        "registerSuccess.second": "2、",
        "registerSuccess.goToBss": "前往",
        "registerSuccess.goToBssFillInfo": "补全注册信息，您将定期收到华为云优惠活动消息。",
        "registerSuccess.bssAccountInfo": "用户中心",
        "registerSuccess.redirecting": "正在为您跳转...",
        "registerSuccess.redirecting.back": "{0}秒后自动返回原页面",
        "registerSuccess.autoClose": "{0}s后自动关闭本页面。",
        "registerSuccess.browserPreventClose": "当前浏览器设置不允许系统自动关闭页面。",
        "registerSuccess.homepage": "首页",
        "registerSuccess.userCenter": "用户中心",
        "registerSuccess.consoleHome": "管理控制台",
        "registerSuccess.helpCenter": "帮助中心",

        "resetPwd.title": "首次登录",
        "resetPwd.titleDetail": "为了提高帐号的安全性，请您修改密码。",
        "resetPwd.phone": "已验证手机：",
        "resetPwd.mailbox": "已验证邮件地址：",
        "resetPwd.byPhone": "通过手机号验证",
        "resetPwd.byMailbox": "通过已验证邮件地址验证",
        "resetPwd.smsMsgCode": "短信验证码：",
        "resetPwd.emailMsgCode": "邮件验证码：",
        "resetPwd.getSmsMsgCode": "免费获取短信验证码",
        "resetPwd.getEmailMsgCode": "免费获取邮件验证码",
        "resetPwd.retrieveMsgCode": "{0}秒后可以重新获取",
        "resetPwd.resetFailed": "密码修改失败。",
        "resetPwd.oldPasswd": "原密码：",
        "resetPwd.newPasswd": "新密码：",
        "resetPwd.confirmNewPasswd": "确认新密码：",
        "resetPwd.resetPwdFailed": "原密码错误，请重试。",
        "resetPwd.getCodeFail": "验证码获取次数达到上限5次，请15分钟后重试",
        "resetPwd.resetCount":"原密码错误，再输错{0}次后需要重新登录。",
        "resetPwd.InitPasswd": "初始密码：",
        "resetPwd.InitPasswdError":"初始密码错误，请重试。",
        "resetPwd.InitPasswdCount":"初始密码错误，再输错{0}次后需要重新登录。",
        "modifyPwdIntervalTimeLessThanMinValidTime": "修改密码时间间隔小于密码必须使用的最短时间，请在密码必须使用的最短时间过后再修改，点击“取消”进入系统。",
        "pwdModifyTitle": "修改密码",
		"pwdExpiredTitle": "密码已经过期",
        "pwdExpiringDesc": "您的密码{0}天后过期，请及时修改密码。",
        "pwdExpiredDesc": "您的密码已过期，请修改密码。",
        "noRight": "您的权限不足，请联系您的管理员增加权限。",

        "browserSupport": "请使用以下浏览器访问华为云",
        "browserSupport.chrome": "Chrome",
        "browserSupport.chromeVersion": "（36.0及以上）",
        "browserSupport.firefox": "FireFox",
        "browserSupport.firefoxVersion": "（35.0及以上）",
        "browserSupport.ie": "Internet Explorer",
        "browserSupport.ieVersion": "（9.0及以上）",
        "countryCodeSelect": "请选择国家码",
        "reactivate.reactivateAccount": "激活帐号",
        "reactivate.pleaseCheckEmail": "您的帐号还未激活，请您登录注册邮件地址，点击激活邮件中的链接激活您的帐号。",
        "advertisement.txt": "免费试用，每日限额100",
        "advertisement.buttonTxt": "立即申请",
        "fphone.changePhoneNum": "更换手机号",
        "fphone.changeSuccess": "完成",
        "fphone.registerEmail": "已验证邮件地址：",
        "fphone.registerEmailPH": "请输入邮件地址",
        "fphone.emailVerifyCode": "邮件验证码：",
        "fphone.getVerifyCodeByEmail": "获取邮件验证码",
        "fphone.emailVerifyCodePH": "请输入邮件验证码",
        "fphone.newPhoneNum": "新手机号：",
        "fphone.newPhoneNumPH": "请输入新手机号",
        "fphone.smsVerifyCode": "短信验证码：",
        "fphone.getVerifyCodeBySms": "获取短信验证码",
        "fphone.smsVerifyCodePH": "请输入短信验证码",
        "fphone.changePhoneSuccess": "手机号更换成功！",
        "fphone.newPhoneNumInfo": "新的手机号：",
        "fphone.phoneRepeat": "该手机号已存在。",
        "fphone.exceedMaxAccounts": "该手机号已绑定6个帐号。",
        "mobileNumber": "手机号：",
        "fphone.changeMobile": "更换手机号",
        "sendSmsIntervalErr": "您的验证码请求过于频繁，请一分钟后再试。",
        "cookie.chromeDesc":"点击浏览器“设置”——“显示高级设置”——“隐私设置”——“内容设置”——取消“阻止第三方cookie和网站数据”——选择“允许设置本地数据（推荐）”——点击“完成”——重启浏览器即可正常登录。",
        "cookie.firefoxDesc" :"点击浏览器“选项”——选择“隐私”——“自定义历史记录设置”，取消“始终使用隐私浏览模式”，勾选“接受来自站点的cookie”——点击“确定”——重启浏览器即可生效。",
        "cookie.ieDesc":"点击浏览器“工具”——“internet选项”——“隐私”——将“阻止所有cookie”调低级别——点击“保存”——重启浏览器即可正常登录。",
        "cookie.chromeName":"Chrome浏览器:",
        "cookie.firefoxName":"Firefox浏览器:",
        "cookie.ieName":"IE浏览器:",
        "cookie.title":"如何开启浏览器cookie？",
        "cookie.loginTip":"开启cookie之后才能登录。",
        "cookie.startCookie":"如何开启？",

        "verifyCode.intervalError": "您的验证码请求过于频繁，请一分钟后再试。",
        "verifyCode.invalid": "验证码已失效，请点击重新获取。",
        "verifyCode.error": "验证码错误，请重新输入。",
        "verifyCode.locked": "获取验证码功能已被锁定，请于次日重试。",
        "verifyCode.locked.custom" : "获取验证码功能已被锁定，请{0}分钟后重试或者联系人工客服4000-955-988获取帮助。",
        "verifyCode.sendFailed": "验证码发送失败,请重新获取。",
        "verifyCode.remainderCount": "再请求获取验证码{0}次，该功能将被锁定。",
        "verifyCode.cantAcquire": "获取验证码功能已被锁定，请输入最后一次获取的验证码。",
        "verifyCode.emailInvalidAndSMSError": "短信验证码错误，请重新输入并重新获取有效的邮件验证码。",
        "verifyCode.email.invalid": "邮件验证码已失效，请点击重新获取。",
        "verifyCode.email.error": "邮件验证码错误，请重新输入。",
        "verifyCode.sms.invalid": "短信验证码已失效，请点击重新获取。",
        "verifyCode.sms.error": "短信验证码错误，请重新输入。",
        "verifyCode.usernameRepeat": "用户名已存在，请重新输入。",
        "verifyCode.maxmiumSubUserNum": "用户数量已达到上限。",
        "verifyCode.emailExist": "邮件地址已存在,请重新输入。",

        "loginVerification": "登录验证",
        "loginVerification.tips": "该提示由您的管理员开启，如需关闭，请联系您的管理员。",
        "loginVerification.presetLoginInfo": "预设登录信息",
        "loginVerification.warningInfo": "如果以上文字与您预设的登录信息不一致，请取消本次登录",
        "loginVerification.checkBySMS": "手机短信验证",
        "loginVerification.SMSHasSentTo": "(短信验证码将发送至您的手机)",
        "loginVerification.pleaseClickAgain": "（如60秒内未收到验证码，请重新点击获取）",
        "loginVerification.userLoginInfo": "用户登录信息",
        "loginVerification.lastSuccessTime": "上次登录成功时间",
        "loginVerification.lastFailedTime": "上次登录失败时间",
        "loginVerification.failedTimes": "当前连续登录失败次数",
        "loginVerification.lockInfo": "连续{0}次登录失败，当前用户将被锁定{1}分钟",
       
        "loginVerification.MFATitle":"虚拟MFA登录验证",
        "loginVerification.MFAContext":"请输入您从Authenticator应用程序中获取6位的MFA验证码。",
        "loginVerification.MFAHelp":"如何获取MFA验证码？",
        "loginVerification.MFALabel":"MFA验证码：",
        "loginVerification.MFANotUseTip":"MFA设备不可用？",
        "loginVerification.MFANotUseMessage1":"您可以联系您公司的华为云管理员重置虚拟MFA设备。",//子用户
        "loginVerification.MFANotUseMessage2": "请联系华为云客服人员。",//租户
        "loginVerification.resetMFAHelpUrl": "<a href='{0}' target='_blank' rel='noopener noreferrer'>如何解绑、重置虚拟MFA？</a>",
        "loginVerification.rememberMFALabel": "7天内无需再次验证",
        "loginVerification.rememberMFALabel.disabledTip": "为了您的帐号安全，同一浏览器仅支持5个用户同时开启“7天内无需再次验证”",

        "loginVerification.emailCheckTitle":"邮箱登录验证",
        "loginVerification.emailCheckContent":"（邮件验证码将发送至您的邮箱：{0}）",
        "loginVerification.emailCodeLabel": "邮件验证码：",
        "loginVerification.emailNotCode":"邮箱不可用",
        "loginVerification.emailCodeTxt":"免费获取邮件验证码",
        "loginVerification.verificationType": "验证方式",
        "loginVerification.verificationTypeForPhone": "绑定手机号与验证方式",
        "loginVerification.verificationTypeForEmail": "绑定邮件地址与验证方式",
        "loginVerification.bindPhone": "绑定手机",
        "loginVerification.bindPhoneTips": "管理员已指定您的验证方式为手机验证，请输入您要绑定的手机号。",
        "loginVerification.bindPhonePH": "请输入要绑定的手机号",
        "loginVerification.bindEmail": "绑定邮箱",
        "loginVerification.bindEmailTips": "管理员已指定您的验证方式为邮箱验证，请输入您要绑定的邮箱。",
        "loginVerification.bindEmailPH": "请输入要绑定的邮箱",
        "loginVerification.verifyCode": "验证码",
        "loginVerification.verifyCodeBtnTxt": "获取验证码",
        "loginVerification.verifyCodePH": "6位数字验证码",
        "loginVerification.verifyCodeEmailPH": "6位数字验证码",
        "loginVerification.sendCodeTxt": "验证码已发送，请勿泄露与他人。",
        "loginVerification.sendCodeFailed": "系统繁忙，获取验证码失败。",
        "loginVerification.validEmailOrPhone": "您输入的邮箱或手机号不可用。",
        "loginVerification.retrieveTxt": "重新获取（{0}）",
        "loginVerification.otherAccount": "切换其他帐号",
        "loginVerification.goOnLogin": "继续登录",
        "loginVerification.title": "绑定虚拟MFA",
        "loginVerification.firstStep": "第一步：请扫描下方二维码下载“华为云”手机应用程序",
        "loginVerification.firstStepIntroduction": "如已下载华为云，请确保您使用的是最新版本。如果您已安装其他MFA应用程序（如 Authenticator），请根据应用程序指引添加用户。",
        "loginVerification.secondStep": "第二步：获取动态码",
        "loginVerification.secondStepIntroduction": "请在手机中打开华为云，选择“控制台-MFA-添加-扫码添加”，扫描下方二维码添加帐号后获取虚拟MFA动态码；或选择“手动输入”，输入下方密钥信息获取虚拟MFA动态码。",
        "loginVerification.username": "IAM用户名",
        "loginVerification.domainname": "帐号名",
        "loginVerification.secretKey": "密钥",
        "loginVerification.thirdStep": "第三步：输入动态码",
        "loginVerification.thirdStepIntroduction": "请输入您从华为云应用程序中获取的连续两组虚拟MFA动态码。",
        "loginVerification.firstRegCode": "第一组验证码",
        "loginVerification.secondRegCode": "第二组验证码",
        "loginVerification.submitText": "确认绑定",
        "loginVerification.bindMFASucceed": "恭喜绑定成功！",
        "loginVerification.mfaCodeError": "MFA验证码校验不通过，请重试！",
        "loginVerification.mfaCodeLocked": "验证码错误次数过多，当前用户已被锁定，请5分钟后重试。",

        "bindAccount.title": "绑定华为云帐号",
        "bindAccount.submit": "注册并绑定",
        "bindAccount.remindCompleteInfo": " 请您补全以下信息，注册华为云帐号并进行绑定。",
        "bindAccount.bindSuccess": " 注册成功！并已绑定华为云帐号",
        "bindAccount.HWSAccount": "您的华为云帐号为：",
        "bindAccount.timeRemind": "{0}秒后自动",
        "bindAccount.redirectPage": "返回原页面",
        "validCountryCode": "请选择有效的国家码",
        "registerGift":"注册成功即可领取超值代金券",
        "registerGiftAddress": "领取代金券",
        "registerGiftSuffixMobile": "领取代金券",
        "registerSuccess.goToGift": "前往",
        "registerSuccess.goToGiftFillInfo": "即可领取新用户专享代金券",

        "welcomeLogin.titleDetail":"为了保障您的帐号安全，请您设置密码。",
        "welcomeEmail.title":"欢迎邮件",
        "welcomeEmail.linkTimeout": "对不起，此链接由于超时已经失效。",
        "welcomeEmail.linkExpired":"对不起，此链接已不可用。",
        "welcomeEmail.resendEmail":"点击此链接重新发送欢迎邮件",
        "welcomeEmail.contactAdm":"请您联系管理员，重新发送欢迎邮件。",
        "welcomeEmail.alreadySend":"欢迎邮件已重新发送。",
        "titles.setPassword":"设置密码—华为云",
        "titles.welcomeEmail":"欢迎邮件—华为云",
        "welcomeEmail.setPassword":"设置密码",
        "dateFormate":"y/M/d HH:mm:ss",
        "sessionExpired":"会话已失效，请重新登录。",
        "m.userNamePlaceHolder":"用户名/邮箱/手机号",
        "m.HongKongUserNamePlaceHolder":"用户名/邮箱",
        "m.accountNamePlaceHolder": "帐号名/邮箱",
        "m.HongKongAccountNamePlaceHolder": "帐号名/邮箱",
        "m.verifyCodePlaceHolder":"验证码",
        "inValidCountryCode": "请选择有效的国家码",
        "mobile.CountryCode":"+86(中国)",
        "authenticationInfo": "未实名认证的用户，部分功能的使用将受到限制。",
        "authenticationForwardInfo": "为了方便您的使用，请您进行实名认证。",
        "authenticationForward": "实名认证",
        "registerSuccess.goToAuthentication":"完成",
        "registerSuccess.authenticationInfo":"，即可获取6个月免费套餐试用资格。",
        "fpwd.findByEmail": "通过邮箱找回密码",
        "fpwd.findByPhone": "通过手机找回密码",
        "fpwd.accountNameByEmail": "已验证邮箱：",
        "fpwd.accountNameByPhone": "注册手机号：",
        "fpwd.phoneAccountNamePH" : "请输入手机号",
        "eChannelName": "华为企业业务合作伙伴",
        "uniportalName": "华为官网帐号",
        "moreLink":"更多",
        "registerSuccess.authenticationForward": "前往实名认证",
        "homepageLink": "首页",
        "helpCenter": "文档",
        "cloudCommunity": "云社区",
        "registerSuccess.goToUserZone": "即刻前往",
        "registerSuccess.userZoneLink": "新用户专区",
        "registerSuccess.userZoneInfo": "，领取专属5折套餐福利。",
        "register.accountPlaceHolder": "请设置您的帐号名",
        "register.passwordPlaceHolder": "请设置您的密码",
        "register.confirmPasswordPlaceHolder": "请再次输入密码",
        "register.phonePlaceHolder": "请输入您的手机号",
        "register.msgCodePlaceHolder": "请输入短信验证码",
        "register.accountNameLength": "5-32个字符",
        "register.bindACccountPlaceHolder":"用户名/邮件地址/手机号",

        "remindBindEmail.title":"绑定邮件地址提醒",
        "remindBindEmail.remindMsg":"您的帐号未绑定邮件地址，请绑定您的邮件地址，以便完成以下操作。",
        "remindBindEmail.remindInfo1":"1、接收云服务开通、到期、删除等重要通知提醒；",
        "remindBindEmail.remindInfo2":"2、重要操作的身份验证，如更改手机号、找回帐号密码、删除云主机等。",
        "remindBindEmail.bind":"立即绑定",
        "remindBindEmail.nextBind":"下次再说",
        "remindBindEmail.remind":"提示",
        "remindBindEmail.remindHideInfo":"请在新标签页绑定电子邮箱。",
        "remindBindEmail.remindHideFailde":"若绑定失败，请尝试",
        "remindBindEmail.remindHideFailde2":"重新绑定",
        "remindBindEmail.remindHideSuccess":"已完成绑定",

        "notify.openPage": "正在执行，请稍等......",
        "notify.closeSecondBefore": "操作成功",
        "notify.closePage": "您已操作成功，请直接关闭当前页面。",

        "registerFailed.accountNameRepeat": "该帐号名已被注册。",
        "register.bindAccountPlaceHolder":"帐号名/邮件地址/手机号",

        "privacyPolicyUpdate": "隐私政策声明更新",
        "privacyTipPre": "尊敬的华为云用户，华为云《隐私政策声明》已更新。华为云深知隐私对您的重要性，并充分尊重您的隐私。请您花一些时间熟悉更新后的",
        "privacyTipSuf": "，了解华为云如何保护您的个人信息。",
        "agreementBtnTxt": "同意",
        "privacyAgreementNotAcceptedError": "请先阅读并同意华为云《隐私政策声明》。",

        "OIDC.errorDefault": "系统繁忙，请联系管理员",
        "OIDC.errorO001": "系统繁忙，请稍后再试",
        "OIDC.errorO002": "无效的请求参数：\"domain_id\"",
        "OIDC.errorO003": "无效的请求参数：\"idp\"",
        "OIDC.errorO004": "无效的请求参数：\"service\"",
        "OIDC.errorO005": "很遗憾，没有找到可用的OpenId Connect配置",
        "OIDC.errorO006": "无效的OpenId Connect配置",
        "OIDC.errorO007": "无效的请求参数：\"id_token\"",
        "OIDC.errorO008": "无效的请求参数：\"state\"",
        "OIDC.errorO009": "无效的JWT",
        "OIDC.errorO010": "访问控制校验失败",
        "OIDC.errorO011": "很遗憾，根据您提供的映射规则，无法获取可用的IAM令牌",
        "OIDC.errorO012": "很遗憾，找不到可登录的项目",
        "OIDC.errorO013": "访问过于频繁，请稍后再试",
        "OIDC.errorO014": "编程访问模式下无法访问控制台",
        "OIDC.errorO015": "无效错误信息",
        "console_term_500Error_label":"系统繁忙，请稍后再试",
        "console_term_404Error_label":"很遗憾，地球我都找遍了，还是没发现您要的页面",
        "console_term_401Error_label":"很遗憾，您访问的页面已失效",
        "titles.loginReminder": "登录提醒—华为云",


        //扫码登录需求相关词条
        "QRLogin.title1": "扫码登录",
        "QRLogin.title2": "登录华为云",
        "QRLogin.countDownTipPre1": "请使用",
        "QRLogin.countDownTipPre2": "华为云APP",
        "QRLogin.countDownTipPre3": "扫描二维码登录",
        "QRLogin.remainingTime": "{0}秒",
        "QRLogin.countDownTipSuffix": "后二维码失效",
        "QRLogin.QRCodeInvalid": "二维码已失效",
        "QRLogin.refresh": "刷新",
        "QRLogin.scanSuc": "扫描成功",
        "QRLogin.scanSucTip": "请在手机上根据提示确认登录",
        "QRLogin.loginFail": "登录失败",
        "QRLogin.loginFailTipPre": "请点击",
        "QRLogin.loginFailTipSuffix": "后，重新扫描二维码登录",
        "QRLogin.downloadApp": "手机下载华为云APP",
        "QRLogin.comma":"，",
        "QRLogin.loginReminder": "登录提醒",
        "QRLogin.accountLogin": "密码登录",

        //统一ID相关
        "hwId.cookieMsg": "我们使用cookie来改善我们的网址和您的体验，继续浏览我们的网址即表示您接受我们的cookie政策。",
        "hwId.hwAccount": "华为帐号",
        "hwId.privacyContent": "我们为您提供华为帐号服务，在登录过程中会使用到您的帐号和网络信息提升登录体验。",
        "hwId.hwportal": "华为官网帐号",
        "hwId.eChannel": "华为企业合作伙伴",
        "hwId.casLogin.systemError": "系统异常",
        "hwId.casLogin.systemErrorDesc": "服务系统异常，请刷新当前页面。 若刷新没反应，请联系人工客服获取帮助：中国大陆 +86 4000 955 988、中国香港 +852 800 931 122。",
        "hwId.casLogin.accountError": "帐号异常",
        "hwId.casLogin.accountErrorDesc": "您当前帐号暂时无法使用华为云服务，请更换其他帐号登录。",
        "hwId.casLogin.accountErrorLink": "了解无法使用",
        "hwId.casLogin.accountErrorUrl": "/zh-cn/iam_faq/iam_01_0006.html",
        "hwId.casLogin.loginError": "登录异常",
        "hwId.casLogin.loginErrorDesc": "您帐号不适用于当前的登录方式，请用华为帐号登录",
        "hwId.casLogin.accountExternalErrorDesc": "您当前帐号的注册地为【欧洲或俄罗斯】，华为云暂时不支持以上地域的帐号，请更换其他地域的帐号登录。",
        "hwId.casLogin.accountExternalErrorLink": "了解无法登录的原因",
        "hwId.casLogin.accountTurkeyErrorLink": "您当前的华为帐号注册地为【土耳其】，华为云暂时不支持该地域的华为账户。建议您<a href='{0}' target='_blank' rel='noopener noreferrer'>立即注册</a>华为云帐号，或使用其他地域的华为帐号进行登录。",
        "hwId.casLogin.inactivatedError": "帐号未激活",
        "hwId.casLogin.inactivatedErrorDesc": "您的帐号尚未激活，系统已自动发送激活邮件到您的注册邮件地址，请在24小时内前往点击邮件地址中的链接完成激活。",
        "hwId.casLogin.inactivatedErrorDesc.noEmail": "您的帐号尚未激活且无邮件地址，暂时无法使用华为云服务，请更换其他帐号重新登录。",
        "hwId.casLogin.inactivatedHwidError": "华为云业务未激活",
        "hwId.casLogin.inactivatedHwidErrorDesc": "您的华为云业务未激活，系统已自动发送激活邮件到您的注册邮件地址，请在24小时内前往点击邮件地址中的链接完成激活。",
        "hwId.casLogin.inactivatedHwidErrorDesc.noEmail": "您的华为云业务尚未激活且无邮件地址，暂时无法使用华为云服务，请更换其他帐号重新登录。",
        "hwId.casLogin.accessErrorDesc": "华为云没有权限获取您当前帐号的信息，暂不支持此帐号登录，请更换其他帐号登录。",
        "hwId.refresh": "刷新",
        "hwId.cookies": "Cookies",
        "hwId.otherAccount": "其他登录方式 ：",
        "hwId.otherAccount.h5": "其他登录方式",
        "hwId.hwIdLogin": "华为帐号登录",
        "hwId.accountPlaceHolder": "租户名/原华为云帐号",

        //统一ID找回密码页面改造
        "fpwd.accountFpwdTitle": "华为云找回密码",
        "fpwd.iamFpwdTitle": "IAM用户找回密码",
        "fpwd.goAccountFpwd": "华为云帐号",
        "fpwd.goIAMFpwd": "IAM用户",
        "fpwd.step2.accountHelpMsg": "以上验证方式不可用，请联系人工客服获取帮助：中国大陆+86 4000955 988、中国香港 +852 800 931 122，若已找回密码，可前往登录。",
        "fpwd.step2.switchPhoneVerify": "更换手机号验证",
        "fpwd.step2.switchEmailVerify": "更换邮件地址验证",
        "fpwd.pwdValidateRule": "密码需满足以下要求：",
        "fpwd.pwdSafetyDegree": "密码强度：",
        "fpwd.selectUserTitle": "请选择本次找回密码的帐号",
        "fpwd.step1.fpwdByEmail": "帐号名/邮件地址找回",
        "fpwd.step1.fpwdByPhone": "手机号找回",
        "fpwd.step1.phoneAccountNamePH": "请输入手机号",
        "fpwd.verifyCodePlaceHolder": "请输入图形验证码",
        "fpwd.accountOrEmailPH": "请输入帐号名/邮件地址",
        "fpwd.IAMAccountPH": "请输入管理员帐号",
        "fpwd.IAMAccountNamePHNew": "请输入IAM用户名/邮件地址",
        "fpwd.step2.sendVerificationCode": "获取验证码",
        "fpwd.confirmPasswdPH": "请确认新密码",
        "fpwd.accountOrEmailPH.h5": "帐号名/邮件地址",
        "fpwd.step1.phoneAccountNamePH.h5": "手机号",
        "fpwd.IAMAccountPH.h5": "管理员帐号",
        "fpwd.IAMAccountNamePHNew.h5": "IAM用户名/邮件地址",
        "fpwd.verifyCodePlaceHolder.h5": "图形验证码",
        "fpwd.newPasswdPH.h5": "新密码",
        "fpwd.confirmPasswdPH.h5": "请确认新密码",
        "fpwd.iamFpwdAccountError": "请输入正确的IAM用户名",

        //统一ID升级提示页面
        "hwId.upgradeTitle": "华为云帐号升级",
        'hwId.upgradeDesc': `您当前登录的华为云帐号仅用于访问华为云，建议立即升级为华为帐号，即可使用一个帐号访问华为云、华为开发者联盟、华为终端（如：华为手机）、
            华为终端云服务（如：云空间、华为视频）等更多华为服务。升级后，请使用华为帐号与密码登录访问华为云，原有华为云资源不受影响。更多详情请`,
        'hwId.upgradeDescLink': '查看公告',
        'hwId.upgradeAgreements.pre': '我同意华为帐号获取我的以下信息：帐号名、手机号、邮件地址、注册国家/地区、登录凭证，我已阅读并同意',
        "hwId.upgradeAgreements.userAgreement": "华为帐号用户协议",
        "hwId.upgradeAgreements.and": "和",
        "hwId.upgradeAgreements.privacyPolicy": "关于华为帐号与隐私的声明",
        "hwId.upgradeAgreements.period": "。",
        "hwId.upgradeBtnTxt": "立即升级",
        "hwId.upgradeCancelBtnTxt": "暂不升级",
        "hwId.upgradePageTitle": "帐号升级——华为云",
        "hwId.upgradeGoBack": "帐号升级",
        "hwId.upgradeErrorTitle": "加载失败",
        "hwId.upgradeErrorDesc": "服务出错了，请联系客服处理",
        "hwId.upgradeErrorBtn": "知道了",
        "hwId.forgetPwd": "忘记密码",
        "hwId.hwCloudAccount": "华为云帐号",
        "hwId.hwCloudAccountLogin": "华为云帐号登录",

        // 快捷登录
        "quickLogin.title": "快捷登录",
        "quickLogin.loginTip": "欢迎使用华为云快捷登录，您可以通过手机/邮件验证码登录华为云",
        "quickLogin.accountInputPH": "手机号/邮件地址/帐号名",
        "quickLogin.smsCodePH": "短信验证码",
        "quickLogin.emailCodePH": "邮件地址验证码",
        "quickLogin.codeBtn": "获取验证码",
        "quickLogin.codeCountdown": "{0}s后重新获取",
        "quickLogin.mobileLogin": "手机号验证",
        "quickLogin.emailLogin": "邮件地址验证",
        "quickLogin.selectUsersTitle": "选择本次登录的帐号",
        "quickLogin.selectUsersTitle.h5": "请选择本次登录的帐号",
        "quickLogin.notAllowed": "该帐号不支持快捷登录，请使用其他帐号登录",
        "quickLogin.smsCodeMsg": "向您的手机号{0}发送验证码",
        "quickLogin.emailCodeMsg": "向您的邮件地址{0}发送验证码",
        "quickLogin.noMobile": "监测到您帐号尚未绑定手机号，请使用邮件地址验证",
        "quickLogin.noEmail": "监测到您帐号尚未绑定邮件地址，请使用手机号验证",
        "quickLogin.qucikLoginTip": "已升级的华为云帐号暂不支持登录，请使用华为帐号登录",
        "quickLogin.notActivate": "当前帐号未激活，不允许使用快捷登录",
        "quickLogin.register": "注册",

        "ssologin.title": "选择要访问的身份提供商",
        "ssologin.btnTxt": "立即访问",
        
        "idpLogin.loginLink": "企业联邦用户",
        "idpLogin.title": "企业联邦身份登录",
        "idpLogin.h5SelectTip": "请选择本次身份供应商名称",
        "idpLogin.accountPh": "原华为云帐号名/租户名",
        "idpLogin.listPh": "身份提供商名称",
        "idpLogin.goLogin": "前往登录",
        "idpLogin.goAccountLogin": "华为云帐号",
        "idpLogin.noIdps": "该帐号检索不到身份供应商，请使用其他华为云帐号名/租户名登录",
        "idpLogin.domainNotExist": "该帐号不存在，请使用其他华为云帐号名/租户名登录",
        
        'selfManage.alertTip': '管理员已关闭“自主管理用户属性”，不支持IAM用户修改基本信息。如需修改，请联系管理员。',
    };

    function i18n(key) {
        return i18n.framework[key];
    }
    i18n.framework = framework;
    return i18n;
});



// WEBPACK FOOTER //
// ./public/hws/i18n/zh-cn/resource.js